module.exports = __webpack_public_path__ + "static/media/Down.eb5af361.svg";